import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface PhotosIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function PhotosIcon({ color = RoutalPalette.neutral00, style = {}, ...props }: PhotosIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 12 12"
      style={{
        height: `12px`,
        width: `12px`,
        strokeLinecap: `round`,
        strokeLinejoin: `round`,
        fill: `transparent`,
        ...style,
      }}
    >
      <g id="Icon_Image" clip-path="url(#clip0_787_19505)">
        <path
          id="Vector"
          d="M3.9 4.58149C4.27638 4.58149 4.58149 4.27638 4.58149 3.9C4.58149 3.52362 4.27638 3.21851 3.9 3.21851C3.52362 3.21851 3.21851 3.52362 3.21851 3.9C3.21851 4.27638 3.52362 4.58149 3.9 4.58149Z"
          fill={color}
          stroke={color}
        />
        <path
          id="Vector_2"
          d="M8.40005 4.80005L11.4 7.80005V10.2298L10.9007 11.1222L10.0199 11.4L1.80005 11.4L8.40005 4.80005Z"
          fill={color}
          stroke={color}
        />
        <path
          id="Vector_3"
          d="M10.2001 0.600098H1.8001C1.13736 0.600098 0.600098 1.13736 0.600098 1.8001V10.2001C0.600098 10.8628 1.13736 11.4001 1.8001 11.4001H10.2001C10.8628 11.4001 11.4001 10.8628 11.4001 10.2001V1.8001C11.4001 1.13736 10.8628 0.600098 10.2001 0.600098Z"
          stroke={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_787_19505">
          <rect width="12" height="12" fill={color} />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
